import * as apps from '../../../enums/apps';

export const hasUnread = (count = {}) => !!count[apps.APP_NAME_INBOX] || !!count[apps.APP_NAME_NOTIFICATIONS];

export const showInboxByDefault = (count = {}) => !count[apps.APP_NAME_NOTIFICATIONS] && !!count[apps.APP_NAME_INBOX];
